import React, { Component } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Pole2SystemsIcon from '../images/bure.jpg'
import Pole1SystemIcon from '../images/yPylon.jpg'
import PortalPicture from '../images/portal3.jpg'
//import { Collapse, Card, CardBody, CardHeader, Form, FormGroup, Label, Input, Col, Row, InputGroupAddon, InputGroup, Button, CardFooter, UncontrolledTooltip } from 'reactstrap';

class PoleDetails extends Component {

    randomNumberBetween = (minValue, maxValue) => this.roundDecimal((Math.random() * (maxValue - minValue) + minValue), 0);
    roundDecimal = (value, decimals) => Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);

    render() {

        let isPortal = this.props.pole.isPortal
        let systems = this.props.pole.sys;
    
        let positionInRoute = !isPortal ? Math.random() < 0.75 ? 'Support' : 'Tension': 'N/A';
        let poleForm = systems === 1 ? 'Cathead' /*'Cathead/Y-form'*/ : 'Barrel';
        let numberOfSystems = systems ? systems : 'N/A';

        let nominalHeight = isPortal ? this.randomNumberBetween(45, 60) : this.randomNumberBetween(30, 50);
        let lowerArmHeight = nominalHeight - this.randomNumberBetween(7, 10, 2);
        let protectionWireHeight = nominalHeight + this.randomNumberBetween(7, 10, 2);

        if(isPortal){
            positionInRoute = this.props.pole.poleIndex === 1 ? 'Starting' : 'Ending';
            poleForm = 'Portal'
            numberOfSystems = 1;
        }

        return (
            <div>
                <span>
                    <h3 style={{margin: '20px'}}><b>Pole details</b></h3>
                    <Divider />
                </span>
                <img 
                    src={this.props.pole.isPortal ? PortalPicture : this.props.pole.sys === 1 ? Pole1SystemIcon : Pole2SystemsIcon} 
                    style={{ width: '200px', marginTop: '15px', marginLeft: '10px' }}
                    alt='Pole'
                />
                <Divider/>
                <List>
                    {/* <ListItem>
                        <ListItemText primary={'OHL: ' + this.props.pole.ohlName} />
                    </ListItem> */}
                    <ListItem>
                        <ListItemText primary={'Name: ' + this.props.pole.poleName} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Pole Nr.: ' + this.props.pole.poleIndex} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Number of systems: ' + numberOfSystems} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Latitude: ' + this.props.pole.lat} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Longitude: ' + this.props.pole.lng} />
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText primary={'Tower Type: Lattice tower' } />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Position in Route: ' + positionInRoute } />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Material: Steel'} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Form of Tower: ' + poleForm} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Fundament Type: Concrete'} />
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText primary={'Nominal Hight: ' + nominalHeight + 'm'} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Hight of Lowest Arm: ' + lowerArmHeight + 'm'} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Protection Wire Hight: ' + protectionWireHeight + 'm'} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Fundament Hight: 1m'} />
                    </ListItem>
                </List>
            </div>
        )
    }
}


export default PoleDetails;

